import { useAppSelector } from 'universal-scripts'
import { DatasetNode } from 'src/types/queries'
import DataSetAboutSkeleton from '@components/skeletons/DataSetAboutSkeleton/DataSetAboutSkeleton'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import DataSetAbout from '@components/DataSetAbout/DataSetAbout'
import { Suspense } from 'react'
import ErrorDatasetInfo from '@components/ErrorBoundary/ErrorDatasetInfo/ErrorDatasetInfo'

import './DataSetView.css'

export default function DataSetView({ node }: { node: DatasetNode }) {
  const datasets = useAppSelector((s) => s.query.datasets)
  const title = datasets.find((d) => d.id === node.id)?.title ?? node.id
  return (
    <div id="data-set-view" className="node-view">
      <h4>{title}</h4>
      <ErrorBoundary errorComponent={ErrorDatasetInfo} key={`about-${node.id}`}>
        <Suspense fallback={<DataSetAboutSkeleton />}>
          <DataSetAbout id={node.id} />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}
